export const OrdinalVariant = [
	{
		value: 1,
		name: 'první dítě',
	},
	{
		value: 2,
		name: 'druhé dítě',
	},
	{
		value: 3,
		name: 'třetí a další dítě',
	},
];

export const ParentsVariant = [
	{
		value: 1,
		name: 'samoživitelka/samoživitel',
	},
	{
		value: 2,
		name: 'oba rodiče',
	},
];

export const NumberOfExpectedChildren = [
	{
		value: 1,
		name: 'jedno',
	},
	{
		value: 2,
		name: 'dvě',
	},
	{
		value: 3,
		name: 'tři',
	},
	{
		value: 4,
		name: 'čtyři',
	},
	{
		value: 5,
		name: 'pět',
	},
];
